<template>
	<div>
		<div v-if="response == ''">
	      <div v-if="!loader">
	        <div class="search" v-if="!overzicht">
	          <i class="fas fa-search bar"></i> <input class="input" type="text" placeholder="Zoeken.." v-model="search">
	        </div>

	        <Categorieen v-if="!overzicht" :categorien="categorien" :cart="cart" :search="search" @changed="ChangedAantal"></Categorieen>
	      
	        <div class="control" v-bind:class="{ marginbutton : !overzicht}" v-if="cart.length != 0">
	          <button @click="Overzicht(_uid)" :id="'button-' +  _uid" class="button is-primary">
	            <div v-if="!overzicht">Naar overzicht</div>
	            <div v-else>Ga terug</div>
	          </button>
	        </div>

	        <Cart key="carti" :cart="cart" v-show="overzicht && cart.length != 0"></Cart>

          <div class="control" v-show="overzicht">
            <button @click="bestellen = !bestellen" class="button is-primary">
              <div>Bestelling</div>
            </button>
          </div>

          <div v-show="overzicht && bestellen">
            <hr style="background: white;"/>
            <div class="field">
              <label class="label"><i class="fas fa-truck-loading" /> Leverancier</label>
              <div class="control">
                <div class="select" style="width:100%" v-bind:class="{'is-danger' : leverancierid == -1, 'is-success' : leverancierid != -1}">
                  <select style="width:100%" v-model='leverancierid'>
                    <option value="-1">...</option>
                    <option
                      v-for="leverancier in leveranciers" 
                      :value="leverancier.id"
                    >{{ leverancier.naam }}</option>
                  </select>
                </div>
                <p class="help is-danger" v-if="leverancierid == -1">Graag invullen</p>
              </div>
            </div>
            <br /><br />
            
            <label class="label">Wachtwoord</label>
            <div class="control">
              <input class="input" v-bind:class="{'is-danger' : password == '', 'is-success' : password == 'mat123'}" type="text" placeholder="Wachtwoord" v-model="password">
            </div>
            
            <p class="help is-danger" v-if="password != 'mat123'">Niet correct</p>

            <label class="label">Leverdatum</label>
            <div class="control">
              <input class="input" type="date" v-model="datum">
            </div>

            <label class="label">Naam</label>
            <div class="control">
              <input class="input" type="text" v-model="levernaam">
            </div>

            <label class="label">Adres</label>
            <div class="control">
              <input class="input" type="text" v-model="leveradres">
            </div>

            <label class="label">Postcode</label>
            <div class="control">
              <input class="input" type="text" v-model="leverpostcode">
            </div>

            <label class="label">Plaats</label>
            <div class="control">
              <input class="input" type="text" v-model="leverplaats">
            </div>

            <label class="label">Referentie</label>
            <div class="control">
              <input class="input" type="text" v-model="leverreferentie">
            </div>

             <label class="label">Telefoonnummer</label>
            <div class="control">
              <input class="input" type="text" v-model="telefoonnummer">
            </div>

            <label class="label">Opmerkingen</label>
            <div class="control">
              <input class="input" type="text" v-model="leveropmerkingen">
            </div>

            <div class="control">
              <button @click="VerzendenBestelling(_uid)" :id="'verzenden-' +  _uid" class="button is-primary" style="margin-bottom:50px;" v-bind:disabled="!(leverancierid != -1 && password == 'mat123')">
                Verstuur bestelling!
              </button>
            </div>

          </div>

	        <div v-show="overzicht && !bestellen">
	          <hr style="background: white;"/>
	          <div class="field">
	            <label class="label"><i class="fa fa-building" /> Bedrijf</label>
	            <div class="control">
	              <div class="select" style="width:100%" v-bind:class="{'is-danger' : bedrijf == -1, 'is-success' : bedrijf != -1}">
	                <select style="width:100%" v-model='bedrijf'>
	                  <option value="-1">...</option>
	                  <option
	                    v-for="bedrijf in bedrijven" 
	                    :value="bedrijf.id"
	                  >{{ bedrijf.naam }}</option>
	                </select>
	              </div>
	              <p class="help is-danger" v-if="bedrijf == -1">Graag invullen</p>
	            </div>
	          </div>
	          <br /><br />

	          <hr style="background: #00b89c;"/>
	          <div class="field">
	            <label class="label"><i class="fa fa-user" /> Afgehandeld door</label>
	            <div class="control">
	              <div class="select" style="width:100%" v-if="afgehandeld != -2" v-bind:class="{'is-danger' : afgehandeld <= 0, 'is-success' : afgehandeld > 0}">
	                <select style="width:100%" v-model='afgehandeld'>
	                  <option value="-1">...</option>
	                  <option
	                    v-for="col in collegas" 
	                    :value="col.id"
	                  >{{ col.naam }}</option>
	                  <option value="-2">Anders ...</option>
	                </select>
	              </div>

	              <div class="control" v-if="afgehandeld == -2">
	                <input class="input" v-bind:class="{'is-danger' : anders_afgehandeld == '', 'is-success' : anders_afgehandeld != ''}" type="text" placeholder="Anders .." v-model="anders_afgehandeld">
	              </div>

	              <p class="help is-danger" v-if="afgehandeld == -1 || afgehandeld == -2 && anders_afgehandeld == ''">Graag invullen</p>
	              
	            </div>
	          </div>
	          <br /><br />
	          
	          <hr style="background: #00b89c;"/>
	          <div class="field">
	            <label class="label"><i class="fas fa-truck-loading"></i> Opgehaald door</label>
	            <div class="control">
	              <input class="input" type="text" placeholder="Werknemer" v-model="opgehaald">
	            </div>
	          </div>
	          <br /><br />

	          <hr style="background: #00b89c;"/>
	          <div class="field">
	            <label class="label"><i class="fas fa-street-view"></i> Werk / plaats</label>
	            <div class="control">
	              <input class="input" type="text" placeholder="Vlieter 9" v-model="werk">
	            </div>
	          </div>
	          <br /><br />

	          <hr style="background: #00b89c;"/>
	          <div class="field">
	            <label class="label"><i class="fa fa-exclamation"></i> Opmerkingen</label>
	            <div class="control">
	              <input class="input" type="text" placeholder="Factuur naar.." v-model="opmerkingen">
	            </div>
	          </div>
	          <br /><br />
	          
	          <hr style="background: #00b89c;"/>
	          
	          <i class="fas fa-signature"></i> Handtekening
	          <VueSignaturePad
	            v-if="bedrijf != -1 && afgehandeld != -1"
	            class="sig"
	            height="200"
	            ref="signaturePad"
	          />

	          <hr style="background: #00b89c;"/>

	          <div class="control">
	            <button @click="Verzenden(_uid)" :id="'verzenden-' +  _uid" class="button is-primary" style="margin-bottom:50px;" v-bind:disabled="bedrijf == -1 || afgehandeld == -1 || afgehandeld == -2 && anders_afgehandeld == ''">
	              Akkoord
	            </button>
	          </div>
	        </div>
	      </div>

	      <div v-if="loader" id="loader">
	        <div class="lds-dual-ring"></div>
	      </div>
	    </div>

	    <div v-else>
	      <article class="message">
	        <div class="message-header">
	          <p>Bericht van server</p>
	          <button class="delete" aria-label="delete" @click="removeResponse"></button>
	        </div>
	        <div class="message-body" v-html="response.data">
	          
	        </div>
	      </article>
	    </div>
	</div>
</template>

<script>
import Categorieen from './Mobile/Categorieen.vue'
import Cart from './Mobile/Cart.vue'
import axios from 'axios'

export default {
  name: 'Mobile',

  data() {
    return {
      search: '',
      categorien: null,
      cart: [],
      overzicht: false,
      bedrijven: null,
      collegas: null,
      opgehaald: '',
      werk: '',
      opmerkingen: '',
      loader: true,
      loading: 0,
      response: '',
      token: '',
      afgehandeld: -1,
      bedrijf: -1,
      anders_afgehandeld: '',
      bestellen: false,
      leveranciers: null,
      leverancierid: -1,
      password: '',
      datum: '',
      leveradres: 'Marsdiep 1',
      leverpostcode: '8321 MC',
      leverplaats: 'Urk',
      levernaam: 'Thuiskwartier',
      leverreferentie: 'Voorraad',
      telefoonnummer: '0527 - 798 000',
      leveropmerkingen: ''
    }
  },

  components: {
    Categorieen,Cart
  },

  methods: {
    removeResponse() {
      this.response = '';
      window.location.href = window.location.href;
    },

    VerzendenBestelling(id) {
      this.loader = true;

      axios.defaults.headers.common['X-CSRF-TOKEN'] = this.token;

      let self = this;

      var list = {
        'bedrijf': this.bedrijf,
        'afgehandeld': this.afgehandeld,
        'opgehaald': this.opgehaald,
        'werk': this.werk,
        'opmerkingen': this.opmerkingen,
        'anders_afgehandeld': this.anders_afgehandeld,
        'datum': this.datum,
        'leveradres': this.leveradres,
        'leverpostcode': this.leverpostcode,
        'leverplaats': this.leverplaats,
        'levernaam': this.levernaam,
        'leveropmerkingen': this.leveropmerkingen,
        'telefoonnummer': this.telefoonnummer,
        'leverreferentie': this.leverreferentie
      }

      axios.post(this.$api + 'api/materialen/verzendenLeverancier', { data: this.cart, list:list, leverancierid : this.leverancierid }).then(function (data) {
        self.loader = false;
        self.response = data;
      });
    },

    Verzenden(id) {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      this.flash('verzenden-' + id);

      this.loader = true;

      axios.defaults.headers.common['X-CSRF-TOKEN'] = this.token;

      let self = this;

      var list = {
        'bedrijf': this.bedrijf,
        'afgehandeld': this.afgehandeld,
        'opgehaald': this.opgehaald,
        'werk': this.werk,
        'opmerkingen': this.opmerkingen,
        'anders_afgehandeld': this.anders_afgehandeld
      }

      axios.post(this.$api + 'api/materialen/verzenden', { data: this.cart, img: data, list:list }).then(function (data) {
        self.loader = false;
        self.response = data;
      });
    },

    flash(id) {
      $('#' + id).addClass('flash');
      setTimeout(function() {
            $('#' + id).removeClass('flash');
      }, 250);
    },

    Overzicht(id) {
      this.flash('button-' + id);

      if(this.overzicht)
        this.overzicht = false
      else 
        this.overzicht = true
    },

    ChangedAantal(val) {
      var exists = false;
      for (var i = this.cart.length - 1; i >= 0; i--) {
        if(this.cart[i].id == val[1].id) {
          var old =  this.cart[i]
          exists = true;
          old.aantal = val[0];
          this.$set(this.cart, i, old);
          

          if(val[0] == 0)
          {
            this.cart.splice(i, 1);
          } 
        }
      }

      if(!exists) {
        val[1].aantal = val[0];
          this.cart.push(val[1])
      }
    }
  },

  mounted() {
    axios.get(this.$api + 'api/materialen/categorien').then(({ data }) => {
      this.categorien = data;
      this.loading += 1;
    });

    axios.get(this.$api + 'api/materialen/bedrijven').then(({ data }) => {
      this.bedrijven = data;
      this.loading += 1;
    });

    axios.get(this.$api + 'api/materialen/leveranciers').then(({ data }) => {
      this.leveranciers = data;
      this.loading += 1;
    });

    axios.get(this.$api + 'api/materialen/collegas').then(({ data }) => {
      this.collegas = data;
      this.loading += 1;
    });

    var result = new Date();
    result.setDate(result.getDate() + 3);

    var day = ("0" + result.getDate()).slice(-2);
    var month = ("0" + (result.getMonth() + 1)).slice(-2);

    var today = result.getFullYear()+"-"+(month)+"-"+(day) ;

    this.datum = today;
  },

  watch: {
    loading: function () {
      if(this.loading == 4) {
        this.loader = false;
      }
    }
  }

}
</script>

<style>
	.control .button {
    width: 100% !important;
  }

  .marginbutton {
    margin-top:50px;
  }

  .control {
    float: left;
    width: 100%;
  }
  .container {
    padding:20px;
  }

  .search {
    position: relative;
  }

  .search input {
    z-index:1;
    padding-left:50px;
    font-size:20px;
  }

  .bar {
    color:#b5b5b5;
    position:absolute;
    z-index:2;
    font-size:35px;
    top:5px;
    left:5px;
    border-radius: 5px;
    border: 1px solid #b5b5b5;
    padding:5px;
  }

  .sig {
    width: 100%;
    height: 200px;
    border: 2px solid #2ab6d6;
  }

  .flash {
      -webkit-animation-name: flash-animation;
      -webkit-animation-duration: 0.3s;

      animation-name: flash-animation;
      animation-duration: 0.3s;
  }

  @-webkit-keyframes flash-animation {  
      from { color: #2ab6d6; }
      to   { color: default; }
  }

  @keyframes flash-animation {  
      from { color: #2ab6d6; }
      to   { color: default; }
  }

  .lds-dual-ring {
	  display: inline-block;
	}

	.lds-dual-ring:after {
	  content: " ";
	  display: block;
	  width: 46px;
	  height: 46px;
	  margin: 1px;
	  border-radius: 50%;
	  border: 5px solid #2ab6d6;
	  border-color: #2ab6d6 transparent #2ab6d6 transparent;
	  animation: lds-dual-ring 1.2s linear infinite;
	}

	@keyframes lds-dual-ring {
	  0% {
	    transform: rotate(0deg);
	  }
	  100% {
	    transform: rotate(360deg);
	  }
	}

	#loader {
	  text-align: center;
	  margin-top: 200px;
	}
</style>